module.exports = __webpack_public_path__ + "img/_granite.1e713b56.jpg";